export default __webpack_public_path__ + "static/media/comp.adaa375a.png";